import { enqueue, syncOne } from "./opQueue";
import { rpc } from "./rpc";

/**
 * Enqueue-First RPC: schreibt zuerst die Operation in die IndexedDB-Queue,
 * versucht dann synchron zu senden. Liefert `{ ok, data, queued }`.
 *
 * queued=true bedeutet Offline-Persistierung; ok=true/false betrifft
 * den Sync-Versuch. Wenn !ok aber retryable -> Badge zeigt "ausstehend",
 * Background-Worker versucht später.
 *
 * payload MUSS `client_operation_id` enthalten (shared_guards §4).
 * Wir lesen sie raus und persistieren sie als top-level-Feld.
 *
 * `photos` (optional): Array von {photoId, entityType}. R12: wandert mit in
 * den Queue-Record -- der PATCH auf die neue Entity passiert in syncOne nach
 * JEDEM erfolgreichen Sync (sofort oder später vom Worker), nicht nur beim
 * Sofort-Erfolg. Fehler dabei sind nicht fatal.
 */
export async function enqueueRpc({
    method = "post",
    path,
    payload,
    rpcName,
    summary,
    photos,
}) {
    const clientOperationId = payload?.client_operation_id || null;
    const rec = await enqueue({
        method,
        path,
        payload,
        clientOperationId,
        rpcName: rpcName || path,
        summary: summary || "",
        photos: (photos || []).filter((p) => p && p.photoId),
    });

    const res = await syncOne(rec);

    return { ...res, queued: true, entryId: rec.id };
}

export { rpc };
